module.exports = __webpack_public_path__ + "img/Hickory PPP V3.a350bc39.png";